export default class Paginator extends HTMLElement {
    static #LEFT_PAGE = `\u00AB`;
    static #RIGHT_PAGE = `\u00BB`;

    #totalPages;
    #pageNeighbours;
    #currentPage;

    connectedCallback() {
        const template = document.createElement('template');
        this.#totalPages = +this.getAttribute('totalPages') || 20;
        this.#pageNeighbours = +this.getAttribute('pageNeighbours') || 2;
        this.#currentPage = +this.getAttribute('currentPage') || 1;
        template.innerHTML = this._template();
        this.attachShadow({mode: 'open'}).appendChild(template.content.cloneNode(true))
        this.shadowRoot.querySelectorAll('a').forEach(a => a.addEventListener('click', this._onPageClick.bind(this)))
        this.setCurrentPage(this.#currentPage)
    }

    /** @return {number} */
    getTotalPages(){
        return this.#totalPages;
    }

    /** @return {number} */
    getCurrentPage(){
        return this.#currentPage;
    }

    setCurrentPage(page) {
        this.#currentPage = page;
        let pageNumbers = this._buildPageNumbers();
        this.shadowRoot.querySelectorAll('ul.pagination li.page-item a.page-link').forEach((a, i) => {
            a.textContent = pageNumbers[i];
            a.parentElement.classList.remove('active')
            if (page === pageNumbers[i]) {
                a.parentElement.classList.add('active')
            }
        });
    }

    _onPageClick(evt) {
        evt.preventDefault();
        if (!isNaN(evt.target.textContent)) {
            if (this.#currentPage !== +evt.target.textContent)
                this.setCurrentPage(+evt.target.textContent);
        } else switch (evt.target.textContent) {
            case Paginator.#LEFT_PAGE:
                this.setCurrentPage(1);
                break;
            case Paginator.#RIGHT_PAGE:
                this.setCurrentPage(this.#totalPages);
                break;
        }
        this.dispatchEvent(new Event('onPageClick'))
    }

    _buildPageNumbers() {
        const totalPages = this.#totalPages;
        const currentPage = this.#currentPage;
        const pageNeighbours = this.#pageNeighbours;

        const totalNumbers = (this.#pageNeighbours * 2) + 3;

        if (totalPages > totalNumbers) {
            const startPage = Math.max(1, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages, currentPage + pageNeighbours);
            let pages = this._range(startPage, endPage);

            const addLeftChevron = startPage > 1;
            const addRightChevron = totalPages > endPage;
            const chevronOffset = totalNumbers - (pages.length+1);

            switch (true) {
                case (addLeftChevron && !addRightChevron): {
                    const extraPages = this._range(startPage - chevronOffset, startPage - 1);
                    pages = [Paginator.#LEFT_PAGE, ...extraPages, ...pages];
                    break;
                }
                case (!addLeftChevron && addRightChevron): {
                    const extraPages = this._range(endPage + 1, endPage + chevronOffset);
                    pages = [...pages, ...extraPages, Paginator.#RIGHT_PAGE];
                    break;
                }
                case (addLeftChevron && addRightChevron):
                default: {
                    pages = [Paginator.#LEFT_PAGE, ...pages, Paginator.#RIGHT_PAGE];
                    break;
                }
            }
            return pages;
        }
        return this._range(1, totalPages);
    }

    _range(from, to) {
        const range = [];
        for (let i = from; i <= to; i++) {
            range.push(i);
        }
        return range;
    }

    _template() {
        const list = this._buildPageNumbers().map(p =>
            `<li class="page-item"><a class="page-link" href="#">${p}</a></li>`
        ).join('');
        return `<style>@import "/ui/js/components/plate/paginator/style.css";</style>
                <ul class="pagination">
                  ${list}
                </ul>`
    }
}
